import React from "react";
import { Box, Typography, CircularProgress } from "@material-ui/core";

interface Props {
  text?: string;
}
export const LoadingNotification = ({ text = "Ladataan..." }: Props): JSX.Element => {
  return (
    <Box p={4} alignSelf="center" textAlign="center">
      <Typography variant="h3">{text}</Typography>
      <CircularProgress color="secondary" />
    </Box>
  );
};
